export const SEARCH_EDIT_HISTORY = 'SEARCH_EDIT_HISTORY';
